import React from 'react'

import RadioOptions from './RadioOptions'

const RadioSection = ({
  title,
  subtitle,
  label1,
  label2,
  selectedOption,
  onSelect,
  isDisabled,
  marginTop,
  color
}) => {
  return (
    <div style={{marginTop}}>
      <div>
        <div className="lp-header" style={{textTransform: "uppercase", color, fontSize: "min(6vw, 24px)"}}>
          {title}
        </div>
        <span style={{color, marginTop: "1vh", fontSize: "min(5vw, 18px)", textAlign: "start", fontFamily: "Futura Light"}}>
          {subtitle}
        </span>
      </div>
      <RadioOptions
        marginTop={"1vh"}
        label1={label1}
        label2={label2}
        selectedOption={selectedOption}
        option1={true}
        option2={false}
        onSelect={val => onSelect(val)}
        isDisabled={isDisabled}
        color={color}
      />
    </div>
  );
}

export default RadioSection;